import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosError } from "axios";
import { CompanyBranchBlockUnblockValidationSchema } from "../schemas/blockUnblockCompanyBranch.schema";

interface UseUnblockClientCompanyBranchProps {
  companyBranchId?: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

const useUnblockClientCompanyBranch = ({ companyBranchId, onSuccess, onError }: UseUnblockClientCompanyBranchProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation<void, AxiosError, CompanyBranchBlockUnblockValidationSchema>({
    mutationKey: ['unblockCompanyBranch', companyBranchId],
    mutationFn: async (data) => {
      await privateAxios.put(`/client/company_branches/${companyBranchId}/enable`, {
        company_branch: data,
      });
    },
    onSuccess,
    onError,
  });
};

export default useUnblockClientCompanyBranch;
